<template>
  <div class="wrapper">
    <div class="tilte-text"> 公众号订单 </div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <div class="flex">
          <Select v-model="searchForm.state" style="width:150px" placeholder="全部状态">
            <Option v-for="item in status_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Input v-model="searchForm.orderNo" placeholder="订单编号" style="width: 150px;" />
          <Select v-model="searchForm.interceptStatus" style="width:150px" placeholder="拦截状态">
            <Option v-for="item in interceptStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <div class="flex">
            <span class="search-text">下单订单类型</span>
            <el-radio-group style="margin-left: 10px" v-model="searchForm.orderType" @input="selectType">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">特惠单</el-radio>
<!--              <el-radio :label="2">竞价单</el-radio>-->
              <el-radio :label="3">秒出单</el-radio>
            </el-radio-group>
          </div>
        </div>
      </template>
      <!--      <template>-->
      <!--        <Input v-model="searchForm.nickName" placeholder="会员昵称" style="width: 150px;" />-->
      <!--      </template>-->
      <!--<template>-->
      <!--<Input v-model="searchForm.phone" placeholder="会员手机" style="width: 150px;" />-->
      <!--</template>-->
      <!--      <template>-->
      <!--        <Input v-model="searchForm.sourceId" placeholder="会员ID" style="width: 150px;" />-->
      <!--      </template>-->
      <!--      <template>-->
      <!--        <span>佣金值</span>-->
      <!--        <Input v-model="searchForm.commissionMix" placeholder="最小佣金值" style="width: 150px;" />-->
      <!--        <span style="padding: 0 5px;">至</span>-->
      <!--        <Input v-model="searchForm.commissionMax" placeholder="最大佣金值" style="width: 150px;" />-->
      <!--      </template>-->
      <template>
        <span class="search-text">下单日期</span>
        <DatePicker type="date" placeholder="开始时间" v-model="searchForm.start_time_bak" style="width: 150px;"></DatePicker>
        <span style="padding: 0 5px;">至</span>
        <DatePicker type="date" placeholder="结束时间" v-model="searchForm.end_time_bak"></DatePicker>
      </template>
      <template>
        <Button type="text" style="background: #FF8622;color: #FFFFFF;" @click="handleFilter">查询</Button>
<!--        <Button type="text" style="background: #FF8622;color: #FFFFFF;" @click="handleOrderExport">订单导出</Button>-->
        <Button type="text" style="background: #FF8622;color: #FFFFFF;" @click="handleReset">重置</Button>
        <!-- <Button type="text" style="border: 1px solid #FF8622; color: #FF8622;">下载报表</Button> -->
      </template>
    </div>
    <div class="table-wrapper">
      <Table border :columns="columns" :data="list" :loading="listLoading">
        <template slot-scope="{ row }" slot="proportion">
          <span>{{row.commissionRate}}%</span>
        </template>
        <template slot-scope="{ row }" slot="state">
          <span v-if="row.state == 6">待出票</span>
          <span v-if="row.state == 8">已出票</span>
          <span v-if="row.state == 9">已读票</span>
          <span v-if="row.state == 10">未结算</span>
          <span v-if="row.state == 20">已结算</span>
          <span v-if="row.state == 15">订单失效</span>
        </template>
<!--        <template slot-scope="{ row }" slot="action">-->
<!--          &lt;!&ndash; v-if="(row.stateStr == '待出票')" &ndash;&gt;-->
<!--          <div class="color-ff4" style="cursor: pointer;color: #FF9734;" v-if="row.canIntercept" @click="interceptBtn(row)">拦截订单</div>-->
<!--          <div class="color-ff4" style="cursor: pointer;color: #3D9EFC;" v-if="row.canCuiTicket == 0" @click="urgeBill(row)">催出票</div>-->
<!--          <div class="color-ff4" style="cursor: pointer;color: #3D9EFC;" v-if="row.canCuiTicket == 1">已催</div>-->
<!--          <div class="color-ff4" style="cursor: pointer;color: #FF9734;" v-if="row.canCancelIntercept" @click="cancelOrderBtn(row)">取消拦截</div>-->
<!--          <div class="color-ff4" style="cursor: pointer" @click="showDetail(row)">查看详情</div>-->
<!--        </template>-->
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.pageNo" show-sizer show-elevator show-total @on-change="changePage"
              @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
    <detail ref='detail'></detail>
    <commission-detail ref='commissionDetail'></commission-detail>

    <!--取消拦截-->
    <el-dialog title="取消拦截" :visible.sync="dialog_close" width="500px">
      <div class="dialog-content">确认取消拦截？</div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_close = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_closeBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--取消拦截-->
    <!--拦截订单-->
    <el-dialog title="拦截订单" :visible.sync="dialog_intercept" width="460px">
      <div class="dialog-content">
        <div class="box">
          <div style="margin-right: 16px;"><span>*</span>拦截原因</div>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3}" placeholder="请输入拦截原因" v-model="interceptReason" style="flex: 1;">
          </el-input>
        </div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_intercept = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_interceptBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--拦截订单-->
    <!--催出票-->
    <el-dialog title="催出票" :visible.sync="dialog_urge" width="460px">
      <div class="dialog-content">
        <div class="hint">确定催促出票？</div>
        <div class="placeholder">每个订单10分钟内只能发起一次催出票。</div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_urge = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_urgeBtnOk()">确定</div>
      </div>
    </el-dialog>
    <!--催出票-->

  </div>
</template>
<script>
import { getPlatformUuid, getToken, getUserUUID, getPlatformName, getHeadImg } from '@/utils/auth'
import { Icon, Table, Page, Button, Select, Option, Input, DatePicker } from 'view-design'
//import { getOrderList } from '@/api/order'
import Detail from '@/components/official/TicketDetail.vue'
import CommissionDetail from '@/components/official/CommissionDetail.vue'
import { getDate, numFormatter } from '@/utils/date'
import order from '@/javaApi/order'
const orderModel = new order()
export default {
  name: 'Order',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker,
    Detail,
    CommissionDetail
  },
  data: function () {
    return {
      platformName: getPlatformName(),
      headImg: getHeadImg(),
      dialog_close: false,
      dialog_intercept: false,
      dialog_urge: false,
      testlist: [{ state: 8 }],
      interceptStatus: [
        { label: '全部', value: '' },
        { label: '未拦截', value: '-1' },
        { label: '已拦截', value: '1' }
      ],
      columns: [
        {
          title: '影票信息',
          key: 'movie_info',
          fixed: 'left',
          width: 250,
          render: (h, params) => {
            let movieInfo = params.row.movieInfo
            if (movieInfo !== '') {
              movieInfo = JSON.parse(movieInfo)
            }
            let movieName = movieInfo[5]
            let movieImage = movieInfo[6]
            let ticketNum = params.row.number + '张'

            let renderData = []
            // if (movieImage) {
            //   renderData.push(
            //     h('img', {
            //       attrs: {
            //         src: movieImage,
            //         style: 'width: 30%;height: auto;margin:15px;float:left;cursor:pointer;'
            //       }
            //     })
            //   )
            // }
            renderData.push(
              h(
                'span',
                {
                  attrs: {
                    style: 'display: block;cursor: pointer;margin-top: 15px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;color:#3A94F2;width: 200px;text-align: center;'
                  }
                },
                movieName
              )
            ),
              renderData.push(
                h(
                  'span',
                  {
                    attrs: {
                      style: 'display: block;cursor: pointer;margin-top: 15px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 200px;text-align: center;'
                    }
                  },
                  ticketNum
                )
              )
            //return renderData
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    background: 'none'
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row)
                    }
                  }
                },
                renderData
              )
            ])
          }
        },
        {
          title: '订单编号',
          key: 'orderNo',
          width: 180
        },
        {
          title: '市场价',
          key: 'marketPrice',
          width: 100
        },
        // {
        //   title: '支付金额（元）',
        //   key: 'price',
        //   width: 150,
        //   render: (h, params) => {
        //     let marketPrice = params.row.orderPrice
        //     let renderData = []
        //     renderData.push(marketPrice)
        //     return renderData
        //   }
        // },
        // {
        //   title: '下单会员',
        //   key: 'nickName_info',
        //   width: 120,
        //   render: (h, params) => {
        //     let nickName = params.row.nickName
        //     let renderData = []
        //     renderData.push(params.row.nickName)
        //     renderData.push('(' + params.row.sourceId + ')')
        //     return renderData
        //   }
        // },
        // {
        //   title: '订单总佣金',
        //   key: 'commissionTotal',
        //   width: 120,
        //   className: 'color-blue',
        //   render: (h, params) => {
        //     return h('div', [
        //       h(
        //         'Button',
        //         {
        //           props: {
        //             type: 'primary',
        //             size: 'small'
        //           },
        //           style: {
        //             background: 'none'
        //           },
        //           on: {
        //             click: () => {
        //               this.showCommissionDetail(params.row)
        //             }
        //           }
        //         },
        //         params.row.commissionTotal
        //       )
        //     ])
        //   }
        // },
        // {
        //   title: '佣金比例',
        //   key: 'proportion',
        //   slot: 'proportion',
        //   width: 110,
        // },
        {
          title: '下单时间',
          key: 'createTime',
          width: 120
        },
        {
          title: '订单状态',
          key: 'state',
          slot: 'state',
          width: 110
        },
        {
          title: '结算时间',
          key: 'settleTime',
          width: 120
        },
        {
          title: '拦截状态',
          key: 'interceptStatusStr',
          width: 110
        },
        // {
        //   title: '操作',
        //   key: 'action',
        //   width: 100,
        //   slot: 'action',
        //   align: 'center'
        // }
      ],
      listLoading: false,
      status_list: [
        { label: '全部', value: '' },
        { label: '待出票', value: '6' },
        { label: '已出票', value: '8' },
        { label: '已读票', value: '9' },
        { label: '已结算', value: '20' },
        { label: '订单失效', value: '15' }
      ],
      list: [],
      activeRow: {},
      interceptReason: '',
      total: 0,
      platformUuid: getPlatformUuid(),
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        state: undefined,
        phone: undefined,
        nickName: undefined,
        orderNo: undefined,
        sourceId: undefined,
        commissionMix: undefined,
        commissionMax: undefined,
        start_time_bak: undefined,
        end_time_bak: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        platformUuid: undefined,
        userUuid: undefined,
        orderType:1,
        loginUUId:getUserUUID()
      },
    }
  },
  computed:{
    path:{
      get(){
        return this.$route.path
      }
    }
  },
  created() {
    // 判断是否高亮
    if(this.path === '/pc/bypassAccountOrder/officialOrder'){
      this.$parent.isActive = 1
    }
    let param = this.$route.query
    if (param.user_id) {
      this.searchForm.userUuid = param.user_id
    }
    if (param.nick_name) {
      this.searchForm.nickName = param.nick_name
    }
    this.getList(true)
  },
  methods: {
    urgeBill(row) {
      console.log('row', row)
      this.dialog_urge = true
      this.activeRow = row
    },
    dialog_urgeBtnOk() {
      orderModel
        .urgeBill({
          orderUUID: this.activeRow.orderNo
        })
        .then(res => {
          console.log('res', res)
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_urge = false
            this.getList(true)
          }else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    dialog_interceptBtnOk() {
      orderModel
        .InterceptOrder({
          orderUUID: this.activeRow.orderNo,
          interceptReason: this.interceptReason,
          // applicantName: this.platformName,
          applicantName: '开放平台',
          applicantUrl: this.headImg
        })
        .then(res => {
          console.log(res)
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_intercept = false
            this.getList(true)
          }else {
            this.$Message.warning(res.data.message)
          }
        })

    },
    dialog_closeBtnOk() {
      orderModel
        .cancelOrder({
          orderUUID: this.activeRow.orderNo
        })
        .then(res => {
          console.log(res)
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_close = false
            this.getList(true)
          }else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    interceptBtn(row) {
      this.interceptReason = ''
      console.log('row', row)
      this.dialog_intercept = true
      this.activeRow = row
    },
    cancelOrderBtn(row) {
      console.log('row', row)
      this.dialog_close = true
      this.activeRow = row
    },
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      // 如果查询的参数为空直接unset 掉
      searchForm = this.formateInit(searchForm)
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (!condition) {
        searchForm.platformUuid = this.platformUuid
      }
      let createTimeStartStr = getDate(searchForm.start_time_bak)
      if (createTimeStartStr) {
        searchForm.createStartTime = createTimeStartStr + ' 00:00:00'
      } else {
        delete searchForm.createStartTime
      }
      let createTimeEndStr = getDate(searchForm.end_time_bak)
      if (createTimeEndStr) {
        searchForm.createEndTime = createTimeEndStr + ' 23:59:59'
      } else {
        delete searchForm.createEndTime
      }

      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      if (searchForm.sourceId) {
        searchForm.sourceId = numFormatter(searchForm.sourceId)
      }
      orderModel.getOrderList(searchForm).then(response => {
        var res = response.data
        this.listLoading = false
        if (res.code != 200) {
          this.$Message.error(res.message)
          return
        }
        this.list = res.data.list
        this.total = res.data.total
      })
    },
    formateData(data) {
      if (!data) {
        return []
      }
      if (!data.length) {
        return []
      }
      let i = 0
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for (i = 0; i < data.length; i++) {
        data[i].sequence = i + 1 + (pageNo - 1) * pageSize
      }
      return data
    },
    formateInit(formData) {
      let objCopy = {}
      for (let key in formData) {
        if (formData[key]) {
          objCopy[key] = formData[key]
        }
      }
      return objCopy
    },
    handleFilter() {
      this.getList(true)
    },
    //订单导出
    handleOrderExport() {
      this.listLoading = true
      let searchForm = Object.assign({}, this.searchForm)
      // 如果查询的参数为空直接unset 掉
      searchForm = this.formateInit(searchForm)
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (!condition) {
        searchForm.platformUuid = this.platformUuid
      }
      let createTimeStartStr = getDate(searchForm.start_time_bak)
      if (createTimeStartStr) {
        searchForm.createStartTime = createTimeStartStr + ' 00:00:00'
      } else {
        delete searchForm.createStartTime
      }
      let createTimeEndStr = getDate(searchForm.end_time_bak)
      if (createTimeEndStr) {
        searchForm.createEndTime = createTimeEndStr + ' 23:59:59'
      } else {
        delete searchForm.createEndTime
      }

      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      delete searchForm.pageNo
      delete searchForm.pageSize
      this.$Message.success('正在下载...')
      searchForm.xToken = getToken()
      searchForm.uuid = getUserUUID()
      searchForm = this.formateInit(searchForm)
      orderModel.exportOrder(searchForm).then(async (res) => {
        this.listLoading = false
        const message = res.data.info || res.data.message
        const code = res.data.code
        if(code === 200){
          await this.$alert( {
            title:'导出数据提示',
            message:'当前数据下载中，请前往 导出中心 查看',
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
            }
          });
        }else {
          this.$Message.error(message);
        }
      })
    },
    formatDate(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      return y + m + d
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pageSize = value
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.pageNo == 1) {
        this.getList()
      }
    },
    showDetail(row) {
      this.$refs.detail.init(row)
    },
    // 佣金详情
    showCommissionDetail(row) {
      this.$refs.commissionDetail.init(row)
    },
    // 选择类型
    selectType(e){
      this.searchForm.orderType = e
      this.getList()
    },
    handleReset(){
      this.searchForm = {
        orderType:1,
        loginUUId:getUserUUID(),
        pageNo: 1,
        pageSize: 10
      }

      this.getList()
    }
  }
}
</script>
<style scoped lang="less">
/deep/.el-dialog__body {
  padding: 0;
  padding-bottom: 20px;
}
.flex {
  display: flex;
  align-items: center;
}
.dialog-content {
  min-height: 120px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 25px;
    span {
      color: red;
    }
    // margin-top: 30px;
  }
  .hint {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
  }
  .placeholder {
    margin-top: 10px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.dialogFooter {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;
  div {
    width: 100px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .dialogFooter-ok {
    background-color: #ff8622;
    color: #ffffff;
  }
}
.wrapper {
  width: 100%;
  font-size: 12px;
}
.wrapper .tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}
.wrapper .table-wrapper {
  margin-top: 30px;
}
.search-wrap .ivu-icon-ios-arrow-down:before {
  color: #232323;
  content: '\F33D';
}
.ivu-date-picker-rel {
  margin: 11px 0;
}
.ivu-table {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 2px;
}
.table-wrapper .ivu-table-header th {
  background-color: #fcfaf8 !important;
}
.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}
.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}
.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #ffffff !important;
}
.ivu-table td.color-blue .ivu-table-cell {
  color: #3a94f2;
}
.search-text{
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/officialOrder.vue